module.exports = __webpack_public_path__ + "static/media/Photo2.d8a49564.jpg";